import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults, validateParameters } from './../../wayfinder'
import nodes from './nodes'
import settings from './settings'
/**
* @see \App\Http\Controllers\Tenant\Branch\BranchTreeController::__invoke
* @see app/Http/Controllers/Tenant/Branch/BranchTreeController.php:19
* @route '/user/branches/show/{node?}'
*/
export const show = (args?: { node?: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/user/branches/show/{node?}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\BranchTreeController::__invoke
* @see app/Http/Controllers/Tenant/Branch/BranchTreeController.php:19
* @route '/user/branches/show/{node?}'
*/
show.url = (args?: { node?: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { node: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { node: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            node: args[0],
        }
    }

    args = applyUrlDefaults(args)

    validateParameters(args, [
        "node",
    ])

    const parsedArgs = {
        node: typeof args?.node === 'object'
        ? args.node.id
        : args?.node,
    }

    return show.definition.url
            .replace('{node?}', parsedArgs.node?.toString() ?? '')
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\BranchTreeController::__invoke
* @see app/Http/Controllers/Tenant/Branch/BranchTreeController.php:19
* @route '/user/branches/show/{node?}'
*/
show.get = (args?: { node?: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\BranchTreeController::__invoke
* @see app/Http/Controllers/Tenant/Branch/BranchTreeController.php:19
* @route '/user/branches/show/{node?}'
*/
show.head = (args?: { node?: number | { id: number } } | [node: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\BranchIndexController::__invoke
* @see app/Http/Controllers/Tenant/Branch/BranchIndexController.php:13
* @route '/user/branches'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/user/branches',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\BranchIndexController::__invoke
* @see app/Http/Controllers/Tenant/Branch/BranchIndexController.php:13
* @route '/user/branches'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\BranchIndexController::__invoke
* @see app/Http/Controllers/Tenant/Branch/BranchIndexController.php:13
* @route '/user/branches'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\BranchIndexController::__invoke
* @see app/Http/Controllers/Tenant/Branch/BranchIndexController.php:13
* @route '/user/branches'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\SelectBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/SelectBranchController.php:18
* @route '/user/branches/select'
*/
export const select = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: select.url(options),
    method: 'post',
})

select.definition = {
    methods: ["post"],
    url: '/user/branches/select',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\SelectBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/SelectBranchController.php:18
* @route '/user/branches/select'
*/
select.url = (options?: RouteQueryOptions) => {
    return select.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\SelectBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/SelectBranchController.php:18
* @route '/user/branches/select'
*/
select.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: select.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\EditBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/EditBranchController.php:15
* @route '/user/branches/{branch}/edit'
*/
export const edit = (args: { branch: number | { id: number } } | [branch: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/user/branches/{branch}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\EditBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/EditBranchController.php:15
* @route '/user/branches/{branch}/edit'
*/
edit.url = (args: { branch: number | { id: number } } | [branch: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { branch: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { branch: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            branch: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        branch: typeof args.branch === 'object'
        ? args.branch.id
        : args.branch,
    }

    return edit.definition.url
            .replace('{branch}', parsedArgs.branch.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\EditBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/EditBranchController.php:15
* @route '/user/branches/{branch}/edit'
*/
edit.get = (args: { branch: number | { id: number } } | [branch: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\EditBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/EditBranchController.php:15
* @route '/user/branches/{branch}/edit'
*/
edit.head = (args: { branch: number | { id: number } } | [branch: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\CreateBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/CreateBranchController.php:11
* @route '/user/branches/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/user/branches/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\CreateBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/CreateBranchController.php:11
* @route '/user/branches/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\CreateBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/CreateBranchController.php:11
* @route '/user/branches/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\CreateBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/CreateBranchController.php:11
* @route '/user/branches/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\StoreBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/StoreBranchController.php:23
* @route '/user/branches'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/user/branches',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\StoreBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/StoreBranchController.php:23
* @route '/user/branches'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\StoreBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/StoreBranchController.php:23
* @route '/user/branches'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/UpdateBranchController.php:15
* @route '/user/branches/{branch}'
*/
export const update = (args: { branch: number | { id: number } } | [branch: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/user/branches/{branch}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/UpdateBranchController.php:15
* @route '/user/branches/{branch}'
*/
update.url = (args: { branch: number | { id: number } } | [branch: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { branch: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { branch: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            branch: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        branch: typeof args.branch === 'object'
        ? args.branch.id
        : args.branch,
    }

    return update.definition.url
            .replace('{branch}', parsedArgs.branch.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\UpdateBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/UpdateBranchController.php:15
* @route '/user/branches/{branch}'
*/
update.patch = (args: { branch: number | { id: number } } | [branch: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\DisableBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/DisableBranchController.php:18
* @route '/user/branches/{branch}'
*/
export const destroy = (args: { branch: number | { id: number } } | [branch: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/user/branches/{branch}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\DisableBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/DisableBranchController.php:18
* @route '/user/branches/{branch}'
*/
destroy.url = (args: { branch: number | { id: number } } | [branch: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { branch: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { branch: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            branch: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        branch: typeof args.branch === 'object'
        ? args.branch.id
        : args.branch,
    }

    return destroy.definition.url
            .replace('{branch}', parsedArgs.branch.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\DisableBranchController::__invoke
* @see app/Http/Controllers/Tenant/Branch/DisableBranchController.php:18
* @route '/user/branches/{branch}'
*/
destroy.delete = (args: { branch: number | { id: number } } | [branch: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const branches = {
    show: Object.assign(show, show),
    index: Object.assign(index, index),
    select: Object.assign(select, select),
    edit: Object.assign(edit, edit),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    nodes: Object.assign(nodes, nodes),
    settings: Object.assign(settings, settings),
}

export default branches